module.exports = "/_next/static/images/a1bd46d34fdcd69a74974cf6a4e23325-doggo-xs.jpg";